module.exports = __webpack_public_path__ + "img/saude2.db4fe2e2.svg";